<template>
  <div>
    <div class="flex flex-row gap-2 mb-2">
      <b-button
        v-permission="'influencers.create'"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="addNew">
        <feather-icon icon="PlusIcon" class="mr-50"/>
        <span class="align-middle">{{ $t('AddNew') }}</span>
      </b-button>

      <b-button
        v-permission="'influencers.approve'"
        variant="outline-primary"
        @click="goToApprovals">
        <feather-icon icon="UserCheckIcon" class="mr-50"/>
        <span class="align-middle">{{ $t('influencer.approvals') }}</span>
        <b-badge v-if="pendingCount > 0" variant="warning" class="ml-50">{{ pendingCount }}</b-badge>
      </b-button>
    </div>

    <Grid
      :service="service"
      route_name="influencers"
      order_column="id">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="name">{{ $t('influencer.name') }}</vs-th>
        <vs-th key="networks">{{ $t('influencer.networks') }}</vs-th>
        <vs-th key="level">{{ $t('influencer.level') }}</vs-th>
        <vs-th key="source" sort-key="source">{{ $t('influencer.source') }}</vs-th>
        <vs-th key="status" sort-key="status">{{ $t('influencer.status') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">{{ tr.id }}</vs-td>
          <vs-td width="25%" key="name">
            <div class="font-medium">{{ _.get(tr, 'name') }}</div>
            <small class="text-muted">{{ _.get(tr, 'email') }}</small>
          </vs-td>
          <vs-td width="25%" key="networks">
            <span v-if="!(tr.social_profiles || []).length" class="text-muted">—</span>
            <span v-for="p in (tr.social_profiles || [])" :key="p.id" class="mr-1">
              <vs-chip transparent color="primary">{{ p.network_label }} @{{ p.handle }}</vs-chip>
            </span>
          </vs-td>
          <vs-td width="12%" key="level">
            <span v-if="_.get(tr, 'level.name')">{{ _.get(tr, 'level.name') }}</span>
            <span v-else class="text-muted">—</span>
          </vs-td>
          <vs-td width="13%" key="source">{{ formatSource(_.get(tr, 'source')) }}</vs-td>
          <vs-td width="10%" key="status">
            <vs-chip transparent :color="statusColor(_.get(tr, 'status'))" class="text-base">
              {{ formatStatus(_.get(tr, 'status')) }}
            </vs-chip>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'influencers.edit'"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                @click="props.edit(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'influencers.delete'"
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                @click="props.destroy(props.data[indextr])"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BButton, BBadge } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import InfluencerService from '@/services/api/InfluencerService'

export default {
  directives: { Ripple },
  components: { BButton, BBadge },
  data: () => ({
    service: null,
    pendingCount: 0
  }),
  methods: {
    addNew() {
      this.$router.push('/influencers/create')
    },
    goToApprovals() {
      this.$router.push('/influencers/approvals')
    },
    formatStatus(status) {
      return this.$t(`influencer.status_.${status}`)
    },
    formatSource(source) {
      return this.$t(`influencer.source_.${source}`)
    },
    statusColor(status) {
      switch (status) {
        case 'AP': return 'success'
        case 'PE': return 'warning'
        case 'SU': return 'warning'
        case 'RJ': return 'danger'
        case 'IN': return 'dark'
        default: return 'primary'
      }
    },
    /**
     * O contador do botão é só uma dica visual: se o usuário não tiver a
     * permissão de aprovação a chamada volta negada, e nesse caso o botão nem
     * aparece — então falhar em silêncio aqui é o comportamento certo.
     */
    loadPendingCount() {
      this.service.pending().then(
        list => { this.pendingCount = (list || []).length },
        () => { this.pendingCount = 0 }
      )
    }
  },
  beforeMount() {
    this.service = InfluencerService.build(this.$vs)
  },
  mounted() {
    this.loadPendingCount()
  }
}
</script>
